module.exports = __webpack_public_path__ + "img/light-check.68fca1de.svg";